import { z } from 'zod';

export const graphic = z.object({
  id: z.number().optional(),
  name: z.string(),
  description: z.string().nullable(),
  externalId: z.number(),
  externalPath: z.string(),
  availableRevisions: z.array(z.string()),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});

export const graphicRevision = z.object({
  revision: z.string(),
  preview: z.string().nullable(),
  updatedBy: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  contentSha256: z.string().nullable(),
});

export const latestGraphicRevision = z.object({
  revision: z.string(),
  contentSha256: z.string().nullable(),
});

export const graphicListItem = graphic.extend({
  latestRevision: latestGraphicRevision.nullable(),
});

export type Graphic = z.infer<typeof graphic>;
export type GraphicRevision = z.infer<typeof graphicRevision>;
export type GraphicListItem = z.infer<typeof graphicListItem>;
export type GraphicAndRevisionList = { graphic: Graphic; revisions: GraphicRevision[] };
